import { TooltipProps } from 'recharts'

import { abbreviateNumber } from '@wiggot/utils'

export const CustomTooltip = ({
  active,
  payload
}: TooltipProps<number, string>) => {
  if (active && payload?.length) {
    const value = abbreviateNumber({
      value: payload[0]?.value ?? 0,
      compact: true
    })
    return (
      <div className="py-1 px-2 rounded-full bg-blue">
        <p className="text-xs text-white">
          {value.number}
          {value.notation}
        </p>
      </div>
    )
  }

  return null
}
